export const isLocal = process.env.APP_ENV === 'local';
